module.exports = __webpack_public_path__ + "static/media/Icon-edit.50564717.png";